import React from 'react'
import {useQuery} from "@tanstack/react-query";
import Spinner from "../components/Spinner/Spinner";
import {Booking} from "../model/Booking";
import {useAppendAuthorizationHeader} from "../utils/connector/api-connector";
import TestsView from "../components/Tests/TestsView";
import {setUrlToHTTPs} from "../utils";
import {useLocation} from "react-router";

interface TestsControllerNewI {
    booking: Booking
}

const TestsControllerNew: React.FC<TestsControllerNewI> = (props) => {
    const {booking} = props
    const location = useLocation()

    const query = new URLSearchParams(location.search)

    let testsComponent = <Spinner/>

    const header = useAppendAuthorizationHeader()
const hasResults = booking.links.result !== undefined


    const testsData = useQuery({
        enabled: hasResults,
        queryKey: ['tests', booking.id],
        queryFn: async () => {
            const data =
                await fetch(setUrlToHTTPs(booking.links.result.href+'/tests'), {...header})
            return data.json()
        }})


    if (!hasResults && query.get('booking') !== undefined) {
        testsComponent = <TestsView created={booking.testDate} booking={booking} tests={undefined} commands={undefined} restrictions={booking.constraints}/>
    }


    if (testsData.isFetched) {
        const _tests = testsData.data
        if (_tests !== undefined) {
            //console.log('Tests: ', testsData)
            const {tests, commands} = _tests._embedded;


            testsComponent = <TestsView created={booking.testDate} booking={booking} tests={tests} commands={commands} restrictions={booking.constraints}/>
        } else {
            testsComponent = <TestsView created={booking.testDate} booking={booking} tests={undefined} commands={undefined} restrictions={booking.constraints}/>
        }
    }

    if (testsData.isError) {
        testsComponent = <span>error</span>
    }

    return (<>{testsComponent}</>)
}
export default TestsControllerNew